<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EBhZYD/tc-custom/9780062059789.jpg?1725419601305" alt="This image is the cover for the book Quest for Mary Magdalene"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quest for Mary Magdalene
      </h1>
      <p class="bookDescription body article font2">
        <b>“A well-researched and page-turning history . . . a narrative as clue-rich as a thriller” from the international bestselling author of <i>The Templars </i>(Ben Wilson, <i>Sunday Times</i>).</b><br/><br/>Mary Magdalene is a larger figure than any text, larger than the Bible or the Church; she has taken on a life of her own. She has been portrayed as a penitent whore, a wealthy woman, Christ’s wife, an adulteress, a symbol of the frailty of women, and an object of veneration. And, to this day, she remains a potent and mysterious figure.<br/><br/>In the manner of a quest, this book follows Mary Magdalene through the centuries, explores how she has been reinterpreted for every age, and examines what she herself reveals about woman and man and the divine. It seeks the real Mary Magdalene in the New Testament and in the gnostic gospels, where she is extolled as the chief disciple of Christ. It investigates how and why the Church recast her as a fallen woman, traces her story through the Renaissance when she became a goddess of beauty and love, and looks at Mary Magdalene as the feminist icon she has become today.<br/><br/>“Haag—by dint of a heady combination of pure zest, great imagination and refreshing irreverence . . . drags Mary Magdalene, kicking and screaming, into the very heart of the Biblical narrative.” —Nicola Barker, <i>Spectator</i><br/><br/>“Mirroring the title and scope of Albert Schweitzer’s <i>The Quest of the Historical Jesus, </i>Haag pushes back legend and myth to uncover the real Mary Magdalene. . . . A thought-provoking re-examination of a misunderstood heroine of the Bible” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Haag
      </h2>
      
      <p class="authorDescription body article"><P>Historian and writer Michael Haag has written widely on the Egyptian, Classical,and Medieval worlds. He is the author of <I>The Templars: The History &#38; the Myth</I>and <I>Alexandria: City of Memory</I>, a definitive study of Cavafy, Forster, and LawrenceDurrell in the city, as well as travel guides to Syria, Lebanon, and Egypt. He livesin London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d323ed5